// เงินอุดหนุนรอบ 3 ที่ "ใช้ไปแล้ว" สำหรับคำนวณยอดที่ได้สิทธิ์แล้ว
// ใช้ค่าจาก server (redeemed_amount — สูตรเดียวกับ redeem_used ตอนยืนยัน) ก่อนเสมอ
// เดิมคำนวณ 600 - balance: ผู้ที่ถูกข้ามสิทธิ์ (passport / ใช้สิทธิ์ไปแล้ว / ขาดสอบ SIM) ได้ balance 0
// → ถือว่าใช้ไป 600 → หน้ายืนยันแสดง "ไม่ต้องชำระ" ทั้งที่ server ออกใบแจ้งหนี้
export const subsidyUsed = ({ alreadySetZero, skipRedemption, redeemableAmount, redeemedAmount }) => {
  if (alreadySetZero) return 0;
  if (typeof redeemedAmount === 'number') return redeemedAmount;
  return skipRedemption ? 0 : (600 - redeemableAmount);   // API เก่าที่ยังไม่มี redeemed_amount
};
